<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 650 : 'auto'"
    style="z-index: 1200 !important;"
  >
    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('console.connectedTenantsHelp.dialogTitle') }}</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text scrollable class="scrollable mt-4">
        <i18n-t
          keypath="console.connectedTenantsHelp.homeRequestConnectionDialog.p1"
          tag="p"
        >
          <template #selectFolderToShare>
            <span class="font-weight-bold">
              {{ $t('console.selectFolderToShare') }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeRequestConnectionDialog.p2"
          tag="p"
        >
          <template #period>
            <span class="font-weight-bold">
              {{ $t('common.time.days', { n: 7 }) }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeRequestConnectionDialog.p3"
          tag="p"
        >
          <template #nonTubeWay>
            <span class="font-weight-bold">
              {{ $t('common.nonTubeWay') }}
            </span>
          </template>
          <template #not>
            <span class="font-weight-bold font-upper-case">
              {{ $t('common.not') }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeRequestConnectionDialog.p4"
          tag="p"
        >
          <template #userManagement>
            <span class="font-weight-bold">
              {{ $t('menus.userPermissions.userManagement') }}
            </span>
          </template>
          <template #not>
            <span class="font-weight-bold font-upper-case">
              {{ $t('common.not') }}
            </span>
          </template>
          <template #teamOnly>
            <span class="font-weight-bold font-upper-case">
              {{ $t('common.teamonly') }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.homeRequestConnectionDialog.p5"
          tag="p"
        >
          <template #sendRequest>
            <span class="font-weight-bold">
              {{ $t('console.sendRequest') }}
            </span>
          </template>
        </i18n-t>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  name: 'HomeTenantCreateDialogHelpDialog',
  mixins: [ DialogActionKeys, DialogModel ],
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0.75rem;

  &:not(:first-child) {
    margin-top: 0.75rem;
  }
}

h3 {
  margin-top: 0.75rem;
}

.font-upper-case {
  text-transform: uppercase;
}
</style>
